// @ts-nocheck
import { createCommissionTemplate } from './commissionTemplateHelpers.js';

export default createCommissionTemplate({
  pharmaceuticalCompanyName: '동광제약',
  targetSheetName: '수수료율',
  headerRowIndex: 2,
  headerRowCount: 1,
  dataStartRowIndex: 3,
  columnMapping: {
    drugCode: '보험코드',
    drugName: '제품명',
    commissionRate: '수수료율',
  },
  requiredHeaders: ['보험코드', '제품명', '성분/함량', '수수료율'],
});
